// eslint-disable-next-line import/no-cycle
import store from '@/store';
import { userHasAnyRole } from '@/utils/userRoles';

// eslint-disable-next-line import/prefer-default-export
export function checkIfUserHasPermission(to, from, next, requiredRoles) {
  const user = store.getters.getUser;
  if (userHasAnyRole(user, requiredRoles)) {
    next();
  } else {
    next('/');
  }
}
